import Router from 'vue-router';
import order from './order';
import activity from './activity.js';
import company from './company.js';


// 提交咨询需求
const Consulting = (r) => require.ensure([], () => r(require('@/pages/svPay/Consulting')), 'Consulting');

/** 公众号文章 */
const article = (r) => require.ensure([], () => r(require('@/pages/article/index')), 'article');
const article01 = (r) => require.ensure([], () => r(require('@/pages/article/index01')), 'article01');
const article02 = (r) => require.ensure([], () => r(require('@/pages/article/index02')), 'article02');
const article03 = (r) => require.ensure([], () => r(require('@/pages/article/index03')), 'article03');
const article04 = (r) => require.ensure([], () => r(require('@/pages/article/index04')), 'article04');
const article05 = (r) => require.ensure([], () => r(require('@/pages/article/index05')), 'article05');
const article06 = (r) => require.ensure([], () => r(require('@/pages/article/index06')), 'article06');
const article07 = (r) => require.ensure([], () => r(require('@/pages/article/index07')), 'article07');
const article08 = (r) => require.ensure([], () => r(require('@/pages/article/index08')), 'article08');
const article09 = (r) => require.ensure([], () => r(require('@/pages/article/index09')), 'article09');
const article10 = (r) => require.ensure([], () => r(require('@/pages/article/index10')), 'article10');
const article11 = (r) => require.ensure([], () => r(require('@/pages/article/index11')), 'article11');
const article12 = (r) => require.ensure([], () => r(require('@/pages/article/index12')), 'article12');
const article13 = (r) => require.ensure([], () => r(require('@/pages/article/index13')), 'article13');
const article14 = (r) => require.ensure([], () => r(require('@/pages/article/index14')), 'article14');
const article15 = (r) => require.ensure([], () => r(require('@/pages/article/index15')), 'article15');
const article16 = (r) => require.ensure([], () => r(require('@/pages/article/index16')), 'article16');
const article17 = (r) => require.ensure([], () => r(require('@/pages/article/index17')), 'article17');
const article18 = (r) => require.ensure([], () => r(require('@/pages/article/index18')), 'article18');
const article19 = (r) => require.ensure([], () => r(require('@/pages/article/index19')), 'article19');
const article20 = (r) => require.ensure([], () => r(require('@/pages/article/index20')), 'article20');


//授权页面重定向
const redirectUri = (r) => require.ensure([], () => r(require('@/pages/common/redirectUri')), 'redirectUri');

//邀请评价
const evaluateSuccess = (r) => require.ensure([], () => r(require('@/pages/activity/evaluate/evaluateSuccess')), 'evaluateSuccess');
//评价顾问
const evaluate = (r) => require.ensure([], () => r(require('@/pages/activity/evaluate/index')), 'evaluate');
//预约服务
const orderService = (r) => require.ensure([], () => r(require('@/pages/activity/evaluate/orderService')), 'orderService');

//直播预约
const zb0817 = (r) => require.ensure([], () => r(require('@/pages/activity/zb0817/index')), 'zb0817');
const hd1207 = (r) => require.ensure([], () => r(require('@/pages/activity/hd1207/index')), 'hd1207');

// 收费服务迁移-失效提醒
const svMigration = (r) => require.ensure([], () => r(require('@/pages/common/migration')), 'migration');

let indexRouterList = [{
    path: '/',
    meta: {
      requireAuth: true,
      title: '大童·童管家',
      noNext: true
    },
  },
  {
    path: '/Consulting',
    component: Consulting,
    name: 'Consulting',
    meta: {
      requireAuth: true,
      title: '提交咨询需求',
    },
  },
  {
    path: '/article',
    component: article,
    meta: {
      requireAuth: true,
      title: '大童·童管家',
    },
  },
  {
    path: '/article01',
    component: article01,
    meta: {
      requireAuth: true,
      title: '大童·童管家',
    },
  },
  {
    path: '/article02',
    component: article02,
    meta: {
      requireAuth: true,
      title: '大童·童管家',
    },
  },
  {
    path: '/article03',
    component: article03,
    meta: {
      requireAuth: true,
      title: '大童·童管家',
    },
  },
  {
    path: '/article04',
    component: article04,
    meta: {
      requireAuth: true,
      title: '大童·童管家',
    },
  },
  {
    path: '/article05',
    component: article05,
    meta: {
      requireAuth: true,
      title: '大童·童管家',
    },
  },
  {
    path: '/article06',
    component: article06,
    meta: {
      requireAuth: true,
      title: '大童·童管家',
    },
  },
  {
    path: '/article07',
    component: article07,
    meta: {
      requireAuth: true,
      title: '大童·童管家',
    },
  },
  {
    path: '/article08',
    component: article08,
    meta: {
      requireAuth: true,
      title: '大童·童管家',
    },
  },
  {
    path: '/article09',
    component: article09,
    meta: {
      requireAuth: true,
      title: '大童·童管家',
    },
  },
  {
    path: '/article10',
    component: article10,
    meta: {
      requireAuth: true,
      title: '大童·童管家',
    },
  },
  {
    path: '/article11',
    component: article11,
    meta: {
      requireAuth: true,
      title: '大童·童管家',
    },
  },
  {
    path: '/article12',
    component: article12,
    meta: {
      requireAuth: true,
      title: '大童·童管家',
    },
  },
  {
    path: '/article13',
    component: article13,
    meta: {
      requireAuth: true,
      title: '大童·童管家',
    },
  },
  {
    path: '/article14',
    component: article14,
    meta: {
      requireAuth: true,
      title: '大童·童管家',
    },
  },
  {
    path: '/article15',
    component: article15,
    meta: {
      requireAuth: true,
      title: '大童·童管家',
    },
  },
  {
    path: '/article16',
    component: article16,
    meta: {
      requireAuth: true,
      title: '大童·童管家',
    },
  },
  {
    path: '/article17',
    component: article17,
    meta: {
      requireAuth: true,
      title: '大童·童管家',
    },
  },
  {
    path: '/article18',
    component: article18,
    meta: {
      requireAuth: true,
      title: '大童·童管家',
    },
  },
  {
    path: '/article19',
    component: article19,
    meta: {
      requireAuth: true,
      title: '大童·童管家',
    },
  },
  {
    path: '/redirectUri',
    component: redirectUri,
    name: "redirectUri",
    meta: {
      requireAuth: true,
      userinfo: true,
      title: '大童保险服务',
    },
  },
  {
    path: '/evaluate',
    component: evaluate,
    meta: {
      title: '评价顾问',
      requireAuth: true,
      userinfo: true,
    }
  }, {
    path: '/evaluateSuccess',
    component: evaluateSuccess,
    meta: {
      title: '评价顾问',
      requireAuth: true
    }
  },
  {
    path: '/orderService',
    component: orderService,
    meta: {
      title: '预约服务',
      requireAuth: true
    }
  },
  {
    path: '/zb0817',
    component: zb0817,
    meta: {
      requireAuth: false,
      title: '大童·童管家',
    },
  },
  {
    path: '/article20',
    component: article20,
    meta: {
      requireAuth: true,
      title: '大童·童管家',
    },
  },
  {
    path: '/hd1207',
    component: hd1207,
    meta: {
      requireAuth: false,
      title: '大童·童管家',
    },
  },
  {
    path: '/migration',
    name: 'migration',
    component: svMigration,
    meta: {
      requireAuth: false,
      title: '链接失效',
    },
  },
];

indexRouterList = indexRouterList.concat(order, activity, company);

export default new Router({
  mode: 'history',
  routes: indexRouterList,
});



// WEBPACK FOOTER //
// ./src/router/index.js